export enum KeyCode {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
}
